<template>
  <OverlayLoader :visible="isLoading" />
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-0">
      <div
        class="d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4"
      >
        <form class="position-relative table-src-form me-0" @submit.prevent>
          <div class="row">
            <div class="col-lg-3 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary strong">Torneo</label>
                <select
                  v-model="filters.tournamentId"
                  class="form-select form-control h-55"
                  aria-label="Default select example"
                  @click="getMatchesByTournament()"
                >
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option
                    :value="item.id"
                    v-for="(item, i) of itemsTournament"
                    :key="i"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary strong">Partido</label>
                <select
                  v-model="filters.matchId"
                  class="form-select form-control h-55"
                  aria-label="Default select example"
                >
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option
                    :value="item.id"
                    v-for="(item, i) of itemsMatch"
                    :key="i"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Jugada</label>
                <input
                  type="text"
                  v-model.trim="filters.playName"
                  class="form-control h-55"
                  placeholder="Ingrese nombre de la Jugada"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Jugador</label>
                <input
                  type="text"
                  v-model.trim="filters.playerName"
                  class="form-control h-55"
                  placeholder="Ingrese nombre del Jugador"
                />
              </div>
            </div>
            <div class="col-lg-3 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Estado</label>
                <select
                  v-model="filters.playStatusId"
                  class="form-select form-control h-55"
                  aria-label="Default select example"
                >
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option
                    :value="item.id"
                    v-for="(item, i) of itemsPlayStatus"
                    :key="i"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-6 col-sm-6 text-end mt-4">
              <div class="d-inline-flex flex-wrap gap-3 justify-content-end">
                <button
                  type="button"
                  @click.prevent="getPlayerComplaints(currentPage)"
                  class="btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                >
                  Buscar
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="default-table-area style-two default-table-width">
        <div class="table-responsive">
          <table class="table align-middle">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col" class="text-center">Torneo</th>
                <th scope="col" class="text-center">Partido</th>
                <th scope="col" class="text-center">Jugada</th>
                <th scope="col" class="text-center">Jugador</th>
                <th scope="col" class="text-center">Estado</th>
                <th scope="col" class="text-center">
                  Creado<br />
                  por
                </th>
                <th scope="col" class="text-center">Fecha <br />creación</th>
                <th scope="col" class="text-center">Modificado <br />por</th>
                <th scope="col" class="text-center">
                  Fecha <br />
                  modificación
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in items" :key="item.id">
                <td>
                  {{ index + 1 + (currentPage - 1) * pageSize }}
                </td>
                <td class="text-body">{{ item.tournament.name }}</td>
                <td class="text-body">{{ item.match.name }}</td>
                <td>{{ item.play.name }}</td>
                <td>{{ item.player.fullName }}</td>
                <td class="text-body text-center">
                  <span
                    @click="
                      item.status === PC_REGISTRADO &&
                        changeStatus(item.id, item.reason.name, item.comment)
                    "
                    class="badge bg-opacity-10 p-2 fs-12 fw-normal"
                    role="button"
                    :class="computeStatusClass(item.status)"
                    :style="{
                      cursor:
                        item.status === PC_REGISTRADO ? 'pointer' : 'default',
                      pointerEvents:
                        item.status === PC_REGISTRADO ? 'auto' : 'none',
                    }"
                  >
                    {{ item.statusDescriptionFinal }}
                  </span>
                </td>
                <td class="text-body">{{ item.createdBy }}</td>
                <td class="text-body">{{ item.createdAtDateTimeString }}</td>
                <td class="text-body">{{ item.updatedBy }}</td>
                <td class="text-body">{{ item.updatedAtDateTimeString }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="p-4 pt-lg-4">
          <Pagination
            :currentPage="currentPage"
            :pageSize="pageSize"
            :totalItems="totalItems"
            @update:page="fetchPage"
          />
        </div>
      </div>
    </div>
  </div>
  <!-- Modal -->
  <div
    id="mdlPayerComplaints"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="mdlPayerComplaintsLabel"
    aria-hidden="true"
    size="large"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="mdlPayerComplaintsLabel">
            Evaluar Denuncia
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-5 col-sm-3">
              <label class="label text-secondary strong">Evidencia:</label>
              <br />
              <img
                :src="`${api_url}/${formPlayerComplaint.multimedia}`"
                alt="Evidencia"
                width="auto"
              />
            </div>
            <div class="col-lg-6 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary strong">Motivo:</label>
                <br />
                <b-label class="label">{{
                  formPlayerComplaint.reasonName
                }}</b-label>
              </div>
              <div class="form-group mb-4" v-if="formPlayerComplaint.comment">
                <label class="label text-secondary strong">Comentario:</label>
                <br />
                <textarea
                  rows="5"
                  style="resize: none"
                  class="form-control text-dark no-resize"
                  v-model.trim="formPlayerComplaint.comment"
                  disabled="true"
                ></textarea>
              </div>
              <div class="form-group mb-4">
                <label class="label text-secondary strong">Estado</label>
                <select
                  v-model="formPlayerComplaint.status"
                  @change="clearError('status')"
                  class="form-select form-control h-45"
                  aria-label="Default select example"
                >
                  <option :value="null">-- Seleccionar --</option>
                  <option
                    :value="playStatus.id"
                    v-for="(playStatus, i) of itemsPlayStatusUpdate"
                    :key="i"
                  >
                    {{ playStatus.name }}
                  </option>
                </select>
                <div v-if="errors.status" class="input-error">
                  {{ errors.status }}
                </div>
              </div>
              <div
                class="form-group mb-4"
                v-if="formPlayerComplaint.status == PC_RECHAZADO"
              >
                <label class="label text-secondary strong"
                  >Razón de rechazo:</label
                >
                <br />
                <textarea
                  rows="5"
                  style="resize: none"
                  class="form-control text-dark no-resize"
                  v-model.trim="formPlayerComplaint.rejectionReason"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary text-white"
            @click="validateForm"
          >
            Guardar
          </button>
          <button
            type="button"
            class="btn btn-danger text-white"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { playerComplaintSchema } from "@/schemas/playerComplaintSchema";
import { defineComponent, ref, onMounted } from "vue";
import Pagination from "@/components/Common/Pagination.vue";
import OverlayLoader from "@/components/Others/OverlayLoader.vue";
import { useToast } from "vue-toastification";
import api from "@/services/api";
import {
  PAGINATION_ITEMS_PER_PAGE,
  STATUS,
  LABELS,
  PLAYERCOMPLAINT_STATUS,
} from "@/utils/constants";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "PlayerComplaints",
  components: {
    Pagination,
    OverlayLoader,
  },
  setup() {
    const api_url = ref(String);
    const isLoading = ref(false);
    const currentPage = ref(1);
    const pageSize = ref(PAGINATION_ITEMS_PER_PAGE);
    const totalItems = ref(0);
    const toast = useToast();

    const itemsPlayStatus = ref<any[]>([]);
    const itemsPlayStatusUpdate = ref<any[]>([]);
    const itemsTournament = ref<any[]>([]);
    const itemsMatch = ref<any[]>([]);
    const items = ref<any[]>([]);
    const PC_REGISTRADO = PLAYERCOMPLAINT_STATUS.REGISTRADO;
    const PC_APROBADO = PLAYERCOMPLAINT_STATUS.APROBADO;
    const PC_RECHAZADO = PLAYERCOMPLAINT_STATUS.RECHAZADO;
    const userLogin = ref<any>({});
    const filters = ref({
      tournamentId: null,
      matchId: null,
      playName: "",
      playerName: "",
      playStatusId: PLAYERCOMPLAINT_STATUS.REGISTRADO,
      isActive: null,
    });

    const formPlayerComplaint = ref({
      id: 0,
      status: null,
      reasonName: "",
      comment: "",
      multimedia: "",
      rejectionReason: "",
    });
    const modalPayerComplaints = ref<any>(null);

    const computeStatusClass = (statusValue: number) => {
      return {
        confirmed: statusValue == PLAYERCOMPLAINT_STATUS.REGISTRADO,
        shipped: statusValue == PLAYERCOMPLAINT_STATUS.APROBADO,
        deactive: statusValue == PLAYERCOMPLAINT_STATUS.RECHAZADO,
      };
    };

    onMounted(async () => {
      await getPlayStatus();
      await getPlayStatusUpdate();
      await getTournaments();
      await getPlayerComplaints(currentPage.value);
      const modalElement = document.getElementById("mdlPayerComplaints");
      if (modalElement) {
        modalPayerComplaints.value = new window.bootstrap.Modal(modalElement);
        modalPayerComplaints.value.hide();
      }

      api_url.value = process.env.VUE_APP_API_URL;

      const userLocal = localStorage.getItem("user");
      if (userLocal) {
        userLogin.value = JSON.parse(userLocal);
      }
    });
    const errors = ref<Record<string, string>>({});
    const validateForm = async () => {
      try {
        errors.value = {};
        await playerComplaintSchema.validate(formPlayerComplaint.value, {
          abortEarly: false,
          context: { id: formPlayerComplaint.value.id },
        });
        isLoading.value = true;

        await confirmChangeStatus();
        isLoading.value = false;
      } catch (err: any) {
        console.log("err: " + err);
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
        isLoading.value = false;
      }
    };
    const clearError = (field: string) => {
      errors.value[field] = "";
    };
    const confirmChangeStatus = async () => {
      isLoading.value = true;

      var obj = {
        id: formPlayerComplaint.value.id,
        status: formPlayerComplaint.value.status,
        rejectionReason: formPlayerComplaint.value.rejectionReason,
      };

      const response: any = await api.put(`/playercomplaint`, obj);

      if (response != 0) {
        toast.success(`La Denuncia fue actualizada con éxito.`, {
          timeout: 2000,
        });
        
        formPlayerComplaint.value.id = 0;
        formPlayerComplaint.value.status = null;
        formPlayerComplaint.value.reasonName = "";
        formPlayerComplaint.value.comment = "";
        formPlayerComplaint.value.rejectionReason = "";
        modalPayerComplaints.value.hide();
        fetchPage(currentPage.value);
      } else {
        toast.error(`La Denuncia no pudo ser actualizada.`, {
          timeout: 2000,
        });
      }
      isLoading.value = false;
    };
    const getPlayStatus = async () => {
      try {
        var params = `type=${0}`;
        const response = await api.get(
          `/common/player-complaint-status?${params}`
        );
        itemsPlayStatus.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };
    const getPlayStatusUpdate = async () => {
      try {
        var params = `type=${1}`;
        const response = await api.get(
          `/common/player-complaint-status?${params}`
        );
        itemsPlayStatusUpdate.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };
    const getTournaments = async () => {
      try {
        var params = `pageNumber=1&pageSize=99999&isActive=true`;

        const response = await api.get(`/tournament?${params}`);

        itemsTournament.value = response.data.list;
      } catch (error) {
        console.error(error);
      }
    };

    const getMatchesByTournament = async () => {
      try {
        var params = `pageNumber=1&pageSize=99999&isActive=true`;

        if (filters.value.tournamentId) {
          params = params + `&tournamentId=${filters.value.tournamentId}`;
        }

        const response = await api.get(`/match?${params}`);

        itemsMatch.value = response.data.list;
      } catch (error) {
        console.error(error);
      }
    };

    const getPlayerComplaints = async (page: number) => {
      try {
        isLoading.value = true;
        var params = `pageNumber=${page}&pageSize=${pageSize.value}`;
        if (filters.value.playName) {
          params = params + `&playName=${filters.value.playName}`;
        }
        if (filters.value.playerName) {
          params = params + `&playerName=${filters.value.playerName}`;
        }
        if (filters.value.tournamentId) {
          params = params + `&tournamentId=${filters.value.tournamentId}`;
        }
        if (filters.value.matchId) {
          params = params + `&matchId=${filters.value.matchId}`;
        }
        if (filters.value.playStatusId) {
          params = params + `&playStatusId=${filters.value.playStatusId}`;
        }
        if (filters.value.isActive) {
          params = params + `&isActive=${filters.value.isActive}`;
        }

        const response = await api.get(`/playercomplaint?${params}`);

        items.value = response.data.list;
        totalItems.value = response.data.rows;
        updateCountPlayerComplaint(response.data.value);
      } catch (error) {
        console.error(error);
      } finally {
        isLoading.value = false;
      }
    };

    const getPlayerComplaintEvidence = async (id: number) => {
      try {
        isLoading.value = true;

        const response = await api.get(`/playercomplaint/${id}`);

        return response.data;
      } catch (error) {
        console.error(error);
      } finally {
        isLoading.value = false;
      }
    };

    const fetchPage = async (page: number) => {
      currentPage.value = page;
      getPlayerComplaints(currentPage.value);
    };

    const changeStatus = async (
      id: number,
      reasonName: string,
      comment: string
    ) => {
      var complaint = (await getPlayerComplaintEvidence(id)) as any;
      formPlayerComplaint.value.id = id;
      formPlayerComplaint.value.reasonName = reasonName;
      formPlayerComplaint.value.comment = comment;
      formPlayerComplaint.value.multimedia = complaint.multimedia;

      modalPayerComplaints.value.show();
    };

    const updateCountPlayerComplaint = (newValue: number) => {
      userLogin.value.countPlayerComplaint = newValue;
      localStorage.setItem("user", JSON.stringify(userLogin.value));
      window.dispatchEvent(new Event("user-updated"));
    };
    return {
      items,
      itemsPlayStatus,
      itemsPlayStatusUpdate,
      itemsTournament,
      itemsMatch,
      currentPage,
      pageSize,
      totalItems,
      STATUS,
      LABELS,
      OverlayLoader,
      filters,
      isLoading,
      computeStatusClass,
      getMatchesByTournament,
      getPlayerComplaints,
      fetchPage,
      changeStatus,
      confirmChangeStatus,
      formPlayerComplaint,
      errors,
      validateForm,
      clearError,
      PC_REGISTRADO,
      PC_APROBADO,
      PC_RECHAZADO,
      api_url,
      userLogin,
      updateCountPlayerComplaint,
    };
  },
});
</script>
